import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
   container: {
      display: props => (props.entities ? 'flex' : 'none'),
      padding: '20px',
      justifyContent: 'space-between',
      '& h6': {
         margin: '40px 0 30px',
         lineHeight: 1,
         textAlign: 'center'
      }
   },
   backButton: {
    color: '#fcfcfc !important'
   },
   header: {
      display: props => (props.entities ? 'flex' : 'none'),
      '& *': {
         backgroundColor: 'blue',
         height: 5
      },
      '& div:nth-child(1)':{
        backgroundColor: '#233A85'
      },
      '& div:nth-child(2)':{
        backgroundColor: '#69BF4A'
      },
      '& div:nth-child(3)':{
        backgroundColor: '#0098DF'
      },
   },
   text: {
      marginTop: 30,
      padding: 20,
      background: '#fafafa',
      textAlign: 'justify',
      '& p': {
         marginBottom: 8,
         fontSize: 12,
         lineHeight: 1.2
      }
   }
}))
